import { UserOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import dayjs from 'dayjs';

function LastRedactionOpinion({ latestRedactionInfos }) {
  const description = latestRedactionInfos?.previousAssignment?.description;
  return (
    <Alert
      className={`${description ? 'gx-display-block' : 'gx-display-none'}`}
      message={
        <div className="gx-p-1">
          <p>{description}</p>
          <div className="gx-d-flex gx-align-items-center gx-justify-content-between gx-text-muted">
            <div
              className="gx-d-flex gx-align-items-start"
              style={{ gap: 6 }}
            >
              <UserOutlined />
              <span>{latestRedactionInfos?.previousAssignment?.user?.fullName}</span>
            </div>
            <div>{dayjs(latestRedactionInfos?.previousAssignment?.opinionDate).format('DD/MM/YYYY HH:mm')}</div>
          </div>
        </div>
      }
      type="info"
    />
  );
}
export default LastRedactionOpinion;
